import React, { Component } from 'react';
import { postServingSystemsForm } from '../../../apis/forms';
import { getCountries, getStatesByCountryId } from '../../../apis/locale';
import toast from '../../../components/toast';
import animatedScrollTo from 'animated-scroll-to';
import { addParamsToUrl } from '../../../utils/';
import ReCAPTCHA from "react-google-recaptcha";

class ServingSystemsForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            firstName: '',
            lastName: '',
            company: '',
            zipcode: '',
            country: 'US',
            email: '',
            phoneNumber: '',
            faxNumber: '',
            comment: '',
            isSending: false,
            countries: [],
            errors: []
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);

        this.recaptchaRef = React.createRef();
    }

    componentDidMount() {
        this.loadCountries();
    }

    loadCountries() {
        getCountries()
            .then(data => {
                this.setState({
                    countries: data
                });
            });
    }

    handleFormSubmit(e) {
        e.preventDefault();

        if (!this.state.isSending) {
            this.setState({
                isSending: true,
                errors: []
            });

            const token = this.recaptchaRef.current.getValue();

            // send form to api
            postServingSystemsForm({
                    firstName: this.state.firstName,
                    lastName: this.state.lastName,
                    company: this.state.company,
                    faxNumber: this.state.faxNumber,
                    zipcode: this.state.zipcode,
                    country: this.state.country,
                    email: this.state.email,
                    phoneNumber: this.state.phoneNumber,
                    comment: this.state.comment,
                    pageName: this.props.pageName,
                    pageUrl: this.props.pageUrl,
                    recaptchaToken: token
                })
                .then(json => {
                    console.log(json);
                    this.setState({
                        isSending: false
                    });

                    if (json.success) {
                        toast.success('Your request has been submitted!');
                        if (this.props.redirectTo) window.location = this.props.redirectTo;
                        else {
                            this.setState({
                                firstName: '',
                                lastName: '',
                                company: '',
                                faxNumber: '',
                                zipcode: '',
                                country: 'US',
                                email: '',
                                phoneNumber: '',
                                comment: ''
                            });
                        }
                    }
                    else {
                        this.setState({
                            errors: json.errors
                        });
                        animatedScrollTo(document.querySelector('#serving-systems-form'));
                    }
                })
                .catch(error => {
                    this.setState({
                        isSending: false
                    });
                    console.log(error);
                    toast.error('There was an issue sending your request. Please try again soon.');
                });
        }
    }

    handleChange(e) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value,
            errors: []
        });
    }

    render() {
        let errors;
        if (this.state.errors.length) {
            errors = <ul className="error-list">
                {this.state.errors.map((error) => (
                    <li>{error}</li>    
                ))}
            </ul>;
        }

        return (
            <form id="serving-systems-form" action="#" method="post" onSubmit={this.handleFormSubmit} ref="">
                {errors}
                <div className="row">
                    <div className="form-group col-md-6">
                        <label htmlFor="firstName">First Name *</label>
                        <input className="form-control" type="text" id="firstName" name="firstName" placeholder="John" required value={this.state.firstName} onChange={this.handleChange} />
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="lastName">Last Name *</label>
                        <input className="form-control" type="text" id="lastName" name="lastName" placeholder="Doe" required value={this.state.lastName} onChange={this.handleChange} />
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="email">Email Address *</label>
                        <input className="form-control" type="email" id="email" name="email" placeholder="johndoe@gmail.com" required value={this.state.email} onChange={this.handleChange} />
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="company">Company *</label>
                        <input className="form-control" type="text" id="company" name="company" placeholder="Acme Studios" required value={this.state.company} onChange={this.handleChange} />
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="phone">Phone Number *</label>
                        <input className="form-control" type="tel" id="phoneNumber" name="phoneNumber" placeholder="123-123-1234" required value={this.state.phoneNumber} onChange={this.handleChange} />
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="faxNumber">Fax Number</label>
                        <input className="form-control" type="tel" id="faxNumber" name="faxNumber" placeholder="123-123-1234" value={this.state.faxNumber} onChange={this.handleChange} />
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="zipcode">Postal Code *</label>
                        <input className="form-control" type="text" id="zipcode" name="zipcode" placeholder="12345" required="" value={this.state.zipcode} onChange={this.handleChange} />
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="country">Country</label>
                        <select className="form-control" id="country" name="country" value={this.state.country} onChange={this.handleChange}>
                            {this.state.countries.map((country) => (
                                <option value={country.countryTwoLetterCode}>{country.countryDisplayName}</option>    
                            ))}
                        </select>
                    </div>
                    <div className="form-group col-md-12">
                        <label htmlFor="comment">Question or Comment *</label>
                        <textarea className="form-control" id="comment" name="comment" placeholder="" rows="3" required value={this.state.comment} onChange={this.handleChange}></textarea>
                    </div>
                    <ReCAPTCHA
                        sitekey="6LcOndkZAAAAAE7Hb968THW1Zyjt3MGCcF4R2NHQ"
                        ref={this.recaptchaRef}
                    />
                    <div className="form-actions col-md-12">
                        <button className="btn" disabled={this.state.isSending}>Send</button>
                    </div>
                </div>
            </form>
        );
    }
}

export default ServingSystemsForm;